{
  "UserGroups": {
    "apiError": "Could not get user groups, please try again later",
    "noUserGroupsMessage": "No user groups",
    "createGroupButton": "Create group",
    "userGroupsTable": {
      "nameHeader": "Name",
      "usersHeader": "Users",
      "buttonText": "Show"
    }
  },
  "userGroupDetails": {
    "backToLink": "Back to user group list",
    "apiError": "Could not get a user group or related data",
    "deleteButton": "Delete user group",
    "deleteUserGroupApiErrorPrefix": "Deleting user group failed:",
    "deleteUserGroupGenericError": "Deleting user group failed for unknown reason.",
    "deleteUserGroupModal": {
      "title": "Delete user group?",
      "confirmationText": "Are you sure you want to delete this user group?",
      "name": "User group: {{name}}",
      "deleteButton": "Delete",
      "cancelButton": "Cancel"
    }
  },
  "createUserGroupModal": {
    "heading": "Create user group",
    "nameInputLabel": "Name"
  },
  "basicInformation": {
    "title": "Group information",
    "nameRowTitle": "Name",
    "deliveryAddressRowTitle": "Delivery address",
    "editButton": "Edit group",
    "editModeTitle": "Edit group",
    "nameTitle": "Name",
    "nameInputLabel": "Name of the group",
    "deliveryAddressTitle": "Delivery address",
    "deliveryAddressText": "Default delivery address for all orders. The company name is set automatically, but the address can be changed during ordering.",
    "streetAddressInputLabel": "Street Address",
    "address1InputLabel": "Additional address information",
    "address2InputLabel": "Additional address information (continued)",
    "postalCodeInputLabel": "Postal code",
    "invalidPostalCode": "Invalid postal code",
    "cityInputLabel": "City",
    "countryInputLabel": "Country",
    "fieldRequired": "Field required",
    "saveButton": "Save changes",
    "closeButton": "Cancel",
    "saveErrorTitle": "Save failed",
    "saveErrorMessage": "Saving user group failed"
  },
  "userGroupUsers": {
    "title": "Group users",
    "usersTable": {
      "nameHeader": "Name",
      "phoneHeader": "Phone",
      "emailHeader": "Email",
      "inactiveUser": "Inactive user",
      "noDataText": "No users in group",
      "apiError": "Could not get available group users"
    }
  },
  "userPermissions": {
    "title": "User permissions",
    "helpText": "These permissions will be given to all users in this group. You can give individual permissions in the user's own page.",
    "saveButton": "SAVE CHANGES",
    "cancelButton": "CANCEL",
    "saveErrorTitle": "Error",
    "saveErrorMessage": "Saving user permissions failed"
  },
  "purchaseLimits": {
    "card": {
      "title": "Purchase limits",
      "productsVisibilityRowTitle": "Visibility in shop",
      "hideProductsInfoText": "Hide products with price over",
      "subscriptionProductsRowTitle": "Number of devices",
      "singleDevicePolicyInfoText": "Limit users to 1 product",
      "noLimitsInfoText": "No limits",
      "override": "override",
      "month": "mon",
      "summaryHideProductsInfoText": "Users of this user group can only see and order products with price up to",
      "summaryDontHideProductsInfoText": "Users of this group can see all products in the shop",
      "summarySingleDevicePolicyInfoText": "They can have only one subscription product at a time",
      "summaryNoSingleDevicePolicyInfoText": "They can have multiple subscription products",
      "summaryNoLimitsInfoText": "Users of this group can purchase any product and any number of products from the shop without any cost limits",
      "editButton": "Edit limits"
    },
    "editModal": {
      "modalHeading": "Edit purchase limits",
      "generalInfo": "These are the default rules for all users in this group. You can override rules for individual users in the user’s own settings page",
      "productsVisibilityTitle": "Limit visibility in shop",
      "procurementLimitOverrideCheckboxLabel": "Override inherited",
      "procurementLimitInputLabel": "Hide devices priced over ({{currency}}/month, excl. VAT)",
      "procurementLimitValueNotSetError": "Procurement limit must have a value",
      "procurementLimitValueNotNumberError": "Procurement limit must be a number",
      "month": "month",
      "procurementLimitSetInfo": "Users of this group can only see and purchase products priced under",
      "procurementLimitNotSetInfo": "Users of this group can see all products in the shop",
      "saveButton": "Save changes",
      "cancelButton": "Cancel",
      "saveApiErrorTitle": "Error",
      "saveApiErrorMessage": "Saving changes failed"
    }
  }
}
